import React from 'react'

import { ReactComponent as CheckMarkIcon } from '@sketch/icons/checkmark-16'
import { SKETCH_WEBSITE } from '@sketch/env-config'

import { Button, Modal, ModalInjectedProps, Text } from '@sketch/components'

import {
  StyledLinkButton,
  StyledIconBulletedList,
  BulletedList,
  BulletedListItem,
} from './WorkspaceSettingsUpsell.styles'

interface UpsellBannerModalProps extends ModalInjectedProps {
  modalBodyText: string
  modalHeaderText: string
}

const BulletedText: React.FCC = ({ children }) => {
  return (
    <BulletedListItem>
      <StyledIconBulletedList as={CheckMarkIcon} />
      <Text pb={3} width="100%">
        {children}
      </Text>
    </BulletedListItem>
  )
}

const WorkspaceSettingsUpsellModal: React.FCC<UpsellBannerModalProps> = ({
  hideModal,
}) => {
  return (
    <Modal
      title="Upgrade Sketch to Scale with Your Business"
      onCancel={hideModal}
      cancelOnClickOutside
    >
      <Modal.Body>
        <Text pb={3} width="100%">
          With our Business Plan you gain:
        </Text>
        <BulletedList>
          <BulletedText>
            Single Sign-On (SSO) for seamless and secure Member access
          </BulletedText>
          <BulletedText>
            More powerful access control over documents and folders
          </BulletedText>
          <BulletedText>Flexible payment options or terms</BulletedText>
          <BulletedText>
            Dedicated support if you have 25 or more Editors
          </BulletedText>
        </BulletedList>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Maybe Later
        </Button>
        <StyledLinkButton
          variant="primary"
          href={`${SKETCH_WEBSITE}/support/contact/`}
          external
        >
          Get in Touch
        </StyledLinkButton>
      </Modal.Footer>
    </Modal>
  )
}

export { WorkspaceSettingsUpsellModal }
